// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function SegmentedControl$Segment(props) {
  let additionalLabelStyle = props.additionalLabelStyle;
  let id = props.id;
  let label = props.label;
  let baseClasses = "py-1 px-2.5 h-[30px] flex items-center \n          text-zinc-600 border border-solid border-zinc-300 \n          border-l-0 font-medium first:border-l first:rounded-l \n          last:rounded-r bg-white cursor-pointer transition-all\n          duration-300 hover:bg-gray-50\n\n          [&:first-of-type]:border-l [&:first-of-type]:rounded-tl \n          [&:first-of-type]:rounded-bl\n\n          [&:last-of-type]:rounded-tr [&:last-of-type]:rounded-br\n        \n          [input:checked+&]:bg-tan-blue-500 [input:checked+&]:border-tan-blue-500\n          [input:checked+&]:text-white";
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("input", {
        className: "sr-only",
        id: id,
        checked: props.checked,
        name: props.name,
        type: "radio",
        onChange: props.onChange
      }),
      JsxRuntime.jsxs("label", {
        children: [
          label !== undefined ? label : null,
          Stdlib_Option.getOr(props.children, null)
        ],
        className: additionalLabelStyle !== undefined ? TailwindMerge.twMerge([
            baseClasses,
            additionalLabelStyle
          ]) : baseClasses,
        htmlFor: id
      })
    ]
  });
}

let Segment = {
  make: SegmentedControl$Segment
};

function SegmentedControl(props) {
  let __fullWidth = props.fullWidth;
  let fullWidth = __fullWidth !== undefined ? __fullWidth : false;
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: TailwindMerge.twMerge([
      "flex flex-row",
      fullWidth ? "[&>label]:flex-grow [&>label]:flex-shrink [&>label]:basis-0 [&>label]:justify-center" : ""
    ])
  });
}

let make = SegmentedControl;

exports.Segment = Segment;
exports.make = make;
/* tailwind-merge Not a pure module */
